import { Box, styled } from '@mui/material';

export const DatePickerActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '24px 16px',
  boxSizing: 'border-box',
  gap: '8px',
});
